import React from 'react';
import { Route } from 'react-router-dom';

import { TrackedRoutes } from '../../components/TrackedRoutes';

import { BuyerList, BuyerProfile, CreateBuyer } from './components';

export const BuyersPage: React.FC = () => {
  return (
    <TrackedRoutes>
      <Route index element={<BuyerList />} />
      <Route path="create" element={<CreateBuyer />} />
      <Route path=":buyerId" element={<BuyerProfile />} />
    </TrackedRoutes>
  );
};
